import { ApiService } from "./api_service";

export class PaymentService extends ApiService {
    static  getPayments(customerId, callback, callback_error) {
        this.executeGet(`payments/${customerId}`, callback, callback_error);
    }

}